module.exports = __webpack_public_path__ + "img/icon4.f019f8d1.png";